import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FigureOrderService } from '../figure-order-service';
import { ReorderFiguresApi, type ReorderFiguresApi as ReorderFiguresApiType } from '../../apis/reorder-figures-api';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

/**
 * 图形顺序管理服务实现
 * 负责调用API进行图形顺序的持久化
 */
@injectable()
export class FigureOrderServiceImpl implements FigureOrderService {
    constructor(
        @inject(ReorderFiguresApi)
        private _reorderFiguresApi: ReorderFiguresApiType,
        @inject(CurrentTaskService)
        private _currentTaskService: CurrentTaskService,
    ) {}

    async reorderFigures(figureIds: string[]): Promise<void> {
        try {
            await this._reorderFiguresApi.reorderFigures(
                this._currentTaskService.taskId,
                { figure_ids: figureIds },
            );
        } catch (error) {
            console.error('重排序图形API调用失败:', error);
            // 重新抛出错误，让调用方处理
            throw error;
        }
    }
}
